import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from 'src/features/auth/AuthContext';
import PageTabs from './PageTabs';
import QuickSearchInline from './QuickSearchInline';

function IconHamburger() {
    return (
        <svg width="18" height="18" viewBox="0 0 24 24" aria-hidden="true">
            <path d="M3 6h18v2H3V6zm0 5h18v2H3v-2zm0 5h18v2H3v-2z" fill="currentColor" />
        </svg>
    );
}

export default function TopBar({
    projectId,
    projectName,
    weekOf,
    onOpenCmd,
    onToggleSidebar,
}: {
    projectId?: string;
    projectName?: string;
    weekOf?: string;
    onOpenCmd: () => void;
    onToggleSidebar?: () => void;
}) {
    const nav = useNavigate();
    const { me, logout } = useAuth();

    return (
        <div className="w-full border-b bg-white">
            <div className="px-4 py-2">
                <div className="grid min-w-0 grid-cols-[minmax(0,1fr)_auto] items-center gap-3 xl:grid-cols-[minmax(220px,320px)_minmax(0,1fr)_auto]">
                    {/* 1블록 */}
                    <div className="flex min-w-0 items-center gap-3">
                        <button
                            type="button"
                            onClick={onToggleSidebar}
                            aria-label="Toggle navigation menu"
                            title="Menu"
                            className="inline-flex h-9 w-9 shrink-0 items-center justify-center rounded-lg border text-sm hover:bg-gray-50 xl:hidden"
                        >
                            <IconHamburger />
                        </button>

                        <div className="min-w-0">
                            <div className="truncate text-sm font-semibold text-gray-900">
                                {projectName || 'Project'}
                            </div>

                            <div className="mt-1 flex items-center gap-2">
                                <button
                                    className="shrink-0 rounded border bg-gray-800 px-2 py-0.5 text-xs text-white hover:bg-white hover:text-gray-700"
                                    onClick={() => nav('/projects')}
                                    type="button"
                                >
                                    All Projects
                                </button>
                            </div>
                        </div>
                    </div>

                    {/* 2블록: 넓은 화면에서만 */}
                    <div className="hidden min-w-0 justify-center xl:flex">
                        {projectId ? <PageTabs projectId={projectId} /> : null}
                    </div>

                    {/* 3블록 */}
                    <div className="flex min-w-0 items-center justify-end gap-2">
                        {/* 아이패드 가로 이상만 Quick Search */}
                        {projectId && (
                            <div className="hidden min-w-0 lg:block xl:w-64">
                                <QuickSearchInline projectId={projectId} weekOf={weekOf} />
                            </div>
                        )}

                        {/* 아이패드 가로 이상만 Quick Menu */}
                        <button
                            onClick={onOpenCmd}
                            className="hidden shrink-0 rounded-lg border px-3 py-1.5 text-sm hover:bg-gray-50 lg:inline-flex"
                            title="Command Palette (Ctrl/⌘+K)"
                            type="button"
                        >
                            ⌘K
                        </button>

                        {/* 아이패드 세로 이하에서도 유지 */}
                        <div className="flex shrink-0 items-center gap-2">
                            {!me?.isGuestOnlyUser && (
                                <button
                                    onClick={() => nav('/account/security')}
                                    className="rounded-lg border px-3 py-1.5 text-xs text-gray-700 hover:bg-gray-50"
                                    type="button"
                                >
                                    비밀번호 변경
                                </button>
                            )}
                            <div className="flex h-8 w-8 items-center justify-center rounded-full bg-gray-200 text-xs font-semibold">
                                {(me?.name?.[0] ?? me?.email?.[0] ?? '?').toUpperCase()}
                            </div>

                            <div className="hidden text-xs font-semibold text-gray-900 sm:block">
                                {me?.name ?? 'Unknown'}
                            </div>

                            <button
                                onClick={() => {
                                    logout();
                                    nav('/login?logged_out=1', { replace: true });
                                }}
                                className="rounded-lg bg-gray-900 px-3 py-1.5 text-xs text-white hover:opacity-90"
                                type="button"
                            >
                                Logout
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
